<script lang="ts">
    import CryptoJS from 'crypto-js'
    import background from './background.jpg'
    import border from './border.svg'
    import headIcon from './head.svg'
    import bodyIcon from './body.svg'
    import tailIcon from './tail.svg'
    import lines from './lines.svg'
    import button from 'src/components/main/#assets/button.svg'
    import star from './star.svg'
    import plus from './plus.svg'
    import cornerTopLeft from './top-left-border.svg'
    import cornerTopRight from './top-right-border.svg'
    import cornerBottomLeft from './bottom-left-border.svg'
    import cornerBottomRight from './bottom-right-border.svg'
    import Slots from 'src/components/cabinet/inventory/components/egg/Slots.svelte'
    import Close from 'src/components/#common/modal/close.svg'

    const agent = navigator.userAgent.toLowerCase()
    const elements = ['crystal', 'dark', 'earth', 'electrical', 'fire', 'iron', 'light', 'water', 'wind']
    let hatchedModalOpen = false
    let slotsActive = false
    let crashActive = true
    let nftCardActive = false
    let rarity
    let randElements
    let nftImageHash
    let nftImage

    function randomElement() {
      return elements[Math.floor(Math.random() * elements.length)]
    }

    function getNftRarity(elements) {
      if (elements[0].element === elements[1].element &&
          elements[1].element === elements[2].element) {
        if (elements[0].subElement === elements[1].subElement &&
            elements[1].subElement === elements[2].subElement) {
          return 4
        } else {
          return 3
        }
      } else if (elements[0].element === elements[1].element ||
                 elements[0].element === elements[2].element ||
                 elements[1].element === elements[2].element) {
        return 2
      } else {
        return 1
      }
    }

    const subElementIds = {
      water: {0: '0', 1: '1', 2: '2'},
      wind: {0: '3', 1: '4', 2: '5'},
      earth: {0: '6', 1: '7', 2: '8'},
      crystal: {0: '9', 1: '10', 2: '11'},
      iron: {0: '12', 1: '13', 2: '14'},
      fire: {0: '15', 1: '16', 2: '17'},
      light: {0: '18', 1: '19', 2: '20'},
      dark: {0: '21', 1: '22', 2: '23'},
      electrical: {0: '24', 1: '25', 2: '25'},
    }

    function hatchingModalOpen() {
      randElements = [
        { element: randomElement(), subElement: Math.floor(Math.random() * 3) },
        { element: randomElement(), subElement: Math.floor(Math.random() * 3) },
        { element: randomElement(), subElement: Math.floor(Math.random() * 3) },
      ]

      rarity = getNftRarity(randElements)

      nftImageHash = `collection=meowgon&${randElements[2].element}-${subElementIds[randElements[2].element][randElements[2].subElement]}-${randElements[1].element}-${subElementIds[randElements[1].element][randElements[1].subElement]}-${randElements[0].element}-${subElementIds[randElements[0].element][randElements[0].subElement]}`
      nftImage = `https://nft-images.realis.network/data/nft/thumb/${CryptoJS.MD5(nftImageHash).toString()}.png`

      crashActive = true
      slotsActive = false
      nftCardActive = false
      hatchedModalOpen = true
    }

    function hatchingHandle() {
      crashActive = false
      slotsActive = true

      if ([2, 3, 4].includes(rarity)) {
        setTimeout(() => {
          nftCardActive = true
        }, 10000)
      } else {
        setTimeout(() => {
          nftCardActive = true
        }, 8500)
      }
    }

    function restart() {
      nftCardActive = false
      hatchingModalOpen()
    }
</script>

<section style="--background: url({background});" id="intro">
    <div class="container">
        <div class="row">
            <div class="col-md-7">
                <h1 class="title">Meowgon <span style="--lines: url({lines});">is not just JPEG</span></h1>
                <div class="d-none d-md-block description">Unifying <i class="nft-word">NFT</i><br>and gaming utility</div>
                <a href="#mint-coming" style="--button: url({button});" class="d-none d-md-table button">Waitlist me</a>
            </div>
            <div class="col-md-5">
                <div class="egg-wrapper" style="--border: url({border});">
                    {#if agent.search('iphone') > -1 || agent.search('ipad') > -1}
                        <img src="/images/animation/egg.webp" class="egg" alt="">
                    {:else}
                        <video autoplay muted loop playsinline class="video">
                            <source src="/videos/egg-default.webm" type="video/webm">
                        </video>
                    {/if}
                    <div class="hatch" on:click={hatchingModalOpen}>
                        <div class="corner top-left" style="--cornerTopLeft: url({cornerTopLeft});"></div>
                        <div class="corner top-right" style="--cornerTopRight: url({cornerTopRight});"></div>
                        <div class="corner bottom-left" style="--cornerBottomLeft: url({cornerBottomLeft});"></div>
                        <div class="corner bottom-right" style="--cornerBottomRight: url({cornerBottomRight});"></div>
                        <span class="d-none d-md-inline-block">Click </span>
                        <span class="d-md-none">Tap </span>
                        to hatch
                    </div>
                </div>
                <div class="description d-md-none">Unifying <i class="nft-word">NFT</i><br>and gaming utility</div>
                <a href="#mint-coming" style="--button: url({button});" class="d-table d-md-none button">Waitlist me</a>
            </div>
        </div>
    </div>
    {#if hatchedModalOpen}
        <div class="nft-modal-backdrop"></div>
        <div class="nft-modal-content" style="background: {nftCardActive && rarity && [2, 3, 4].includes(rarity) ? '#0f0803' : '#191004'}">
            {#if crashActive}
                <video autoplay muted playsinline class="video" on:ended={hatchingHandle}>
                    <source src="/videos/egg-crash.mp4" type="video/mp4">
                </video>
            {/if}
            {#if slotsActive}
                <Slots elements={randElements} rarity={rarity}/>
            {/if}
            {#if nftCardActive}
                <button on:click={() => { hatchedModalOpen = false }} class="btn-close" style="--Close:url({Close});"></button>
                {#if [2, 3, 4].includes(rarity)}
                    <video autoplay muted playsinline class="video">
                        <source src="/videos/hatched-{rarity}.mp4" type="video/mp4">
                    </video>
                {/if}
                {#if nftImage}
                    <img src="{nftImage}" class="nft-image" alt="">
                {/if}
                {#if rarity}
                    <div class="stars-wrapper">
                        <div class="stars">
                            <div class="stars-shadow"></div>
                            {#each {length: rarity + 2} as _, i}
                                {#if i < 5}<img src="{star}" alt="star">{/if}
                            {/each}
                            {#if rarity === 4}
                                <img src="{plus}" class="plus" alt="plus">
                            {/if}
                        </div>
                    </div>
                {/if}
                <button class="modal-button" style="--button: url({button});" on:click={restart}>Try again</button>
                <a href="#mint-coming" class="waitlist-button" on:click={() => hatchedModalOpen = false}>Waitlist me</a>
            {/if}
        </div>
    {/if}
    <div class="preload">
        <img src={headIcon} alt="">
        <img src={bodyIcon} alt="">
        <img src={tailIcon} alt="">
        <video src="/videos/egg-crash.mp4" preload="auto" controls autoplay muted></video>
        {#each elements as element}
            <img src="/images/elements/{element}-0.svg" alt="">
            <img src="/images/elements/{element}-1.svg" alt="">
            <img src="/images/elements/{element}-2.svg" alt="">
        {/each}
        {#if nftImage}
            <img src="{nftImage}" alt="">
        {/if}
        {#if rarity && [2, 3, 4].includes(rarity)}
            <video src="/videos/hatched-{rarity}.mp4" preload="auto" controls autoplay muted></video>
        {/if}
    </div>
</section>

<style>
    @-webkit-keyframes jello {
        from, 11.1%, to {
            -webkit-transform: none;
            transform: none;
        }

        22.2% {
            -webkit-transform: skewX(-8.5deg) skewY(-12.5deg);
            transform: skewX(-12.5deg) skewY(-12.5deg);
        }

        33.3% {
            -webkit-transform: skewX(6.25deg) skewY(6.25deg);
            transform: skewX(6.25deg) skewY(6.25deg);
        }

        44.4% {
            -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
            transform: skewX(-3.125deg) skewY(-3.125deg);
        }

        55.5% {
            -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
            transform: skewX(1.5625deg) skewY(1.5625deg);
        }

        66.6% {
            -webkit-transform: skewX(-0.78125deg) skewY(-0.78125deg);
            transform: skewX(-0.78125deg) skewY(-0.78125deg);
        }

        77.7% {
            -webkit-transform: skewX(0.390625deg) skewY(0.390625deg);
            transform: skewX(0.390625deg) skewY(0.390625deg);
        }

        88.8% {
            -webkit-transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
            transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
        }
    }

    .btn-close {
        position: absolute;
        background: var(--Close) no-repeat center;
        top: 18px;
        right: 18px;
        font-size: 14px;
        opacity: 0.8;
        box-shadow: none !important;
        width: 40px;
        height: 40px;
        filter: invert(1);
        z-index: 3;
        transition: .2s;
    }

    .btn-close:hover {
        opacity: 1;
    }

    .modal-button {
        position: absolute;
        bottom: 35px;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 0;
        font-size: 26px;
        font-weight: 600;
        text-decoration: none;
        color: white;
        background: var(--button) no-repeat center;
        background-size: contain;
        padding: 20px 42px 14px;
        text-transform: uppercase;
        line-height: 100%;
        user-select: none;
        white-space: nowrap;
        transition: .25s;
        z-index: 3;
    }

    .modal-button:hover {
        transform: translate(-50%, -50%) scale(1.05);
    }

    .nft-modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1040;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        backdrop-filter: blur(6px);
    }

    .waitlist-button {
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 0;
        font-size: 20px;
        font-weight: 600;
        text-decoration: none;
        color: white;
        background-size: contain;
        padding: 1px 2px;
        line-height: 100%;
        user-select: none;
        white-space: nowrap;
        border-bottom: 2px solid white;
        text-shadow: 0 0 15px black;
        transition: .25s;
        z-index: 3;
    }

    .nft-modal-content {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 2px solid #b3b2b0;
        border-radius: 15px;
        width: 550px;
        height: 630px;
        overflow: hidden;
        transition: .3s;
        z-index: 1050;
    }

    .nft-modal-content:before {
        content: "";
        border-radius: 445px;
        background: rgba(255, 153, 0, 0.50);
        filter: blur(100px);
        width: 100%;
        height: 100%;
        position: fixed;
        display: none;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1051;
    }

    .stars-wrapper {
        position: absolute;
        width: 100%;
        left: 0;
        top: 405px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 15px;
        z-index: 2;
    }

    @keyframes starsAnimation {
        0% {
            transform: scale(0);
            margin-top: 0;
        }
        50% {
            transform: scale(0.5);
            margin-top: -30px;
        }
        100% {
            transform: scale(1);
            margin-top: 0;
        }
    }

    .stars {
        z-index: 2;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: starsAnimation ease-out 0.45s forwards;
    }

    .stars-shadow {
        position: absolute;
        width: 100%;
        height: 80%;
        background: white;
        top: 10%;
        left: 0;
        border-radius: 30px;
        filter: blur(12px);
        opacity: 0.5;
    }

    .stars img {
        margin: 0 3px;
        position: relative;
        z-index: 2;
    }

    section {
        padding-top: 160px;
        padding-bottom: 120px;
        background: var(--background) no-repeat center;
        background-size: cover;
    }

    .title {
        margin-top: 130px;
        margin-bottom: 20px;
        font-style: italic;
        color: white;
        font-size: 100px;
        font-weight: 600;
        text-transform: uppercase;
        line-height: 100%;
    }

    .title span {
        font-weight: 200;
        font-size: 50px;
        text-transform: none;
        position: relative;
    }

    .title span:after {
        content: "";
        position: absolute;
        width: 360px;
        height: 28px;
        left: 50%;
        top: 100%;
        margin-left: -180px;
        background: var(--lines) no-repeat center;
    }

    .description {
        margin-bottom: 70px;
        font-size: 80px;
        font-weight: 500;
        line-height: 120%;
        color: white;
    }

    .nft-word {
        font-size: 100px;
        font-style: italic;
        font-weight: 800;
        padding-right: 10px;
        background: linear-gradient(to right, white 0%, #FFB287);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .button {
        font-size: 40px;
        font-weight: 600;
        text-decoration: none;
        color: white;
        background: var(--button) no-repeat center;
        background-size: contain;
        padding: 38px 75px 32px;
        text-transform: uppercase;
        line-height: 100%;
        user-select: none;
        transition: .25s;
    }

    .button:hover {
        transform: scale(1.05);
    }

    .egg-wrapper {
        height: 800px;
        background: var(--border) no-repeat center;
        background-size: contain;
        position: relative;
    }

    .egg-wrapper:before {
        content: "";
        border-radius: 100%;
        background: rgba(0, 148, 255, 0.6);
        filter: blur(400px);
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;
    }

    .video-egg {
        width: 100%;
        height: auto;
        margin: 0 auto;
        display: block;
        position: relative;
        z-index: 2;
    }

    .egg {
        width: 100%;
        height: auto;
        margin: 0 auto;
        display: block;
        position: relative;
        z-index: 2;
    }

    .video {
        width: 100%;
        position: relative;
        z-index: 2;
    }

    @keyframes nftImageAnimation {
        0% {
            transform: translate(-50%, -30%) scale(0);
        }
        65% {
            transform: translate(-50%, -60%) scale(0.5);
        }
        100% {
            transform: translate(-50%, -50%) scale(1);
        }
    }

    .nft-image {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0);
        width: 380px;
        margin-top: -110px;
        animation: nftImageAnimation ease-out 0.45s 0.1s forwards;
        z-index: 2;
    }

    .hatch {
        position: absolute;
        top: 50%;
        font-size: 32px;
        margin-top: -30px;
        padding: 28px 36px;
        left: 50%;
        transform: translateX(-50%);
        color: white;
        z-index: 2;
        background: rgba(0, 0, 0, 0.2);
        font-family: "Sarpanch", sans-serif;
        user-select: none;
        cursor: pointer;
    }

    .corner {
        width: 15px;
        height: 15px;
        position: absolute;
        transition: .3s;
    }

    .preload {
        width: 1px;
        height: 1px;
        position: absolute;
        overflow: hidden;
        left: -100%;
    }

    .corner.top-left {
        top: 0;
        left: 0;
        background: var(--cornerTopLeft) no-repeat top left;
    }

    .corner.top-right {
        top: 0;
        right: 0;
        background: var(--cornerTopRight) no-repeat top right;
    }

    .corner.bottom-left {
        bottom: 0;
        left: 0;
        background: var(--cornerBottomLeft) no-repeat bottom left;
    }

    .corner.bottom-right {
        bottom: 0;
        right: 0;
        background: var(--cornerBottomRight) no-repeat bottom right;
    }

    .hatch:hover .corner.top-left {
        top: -10px;
        left: -10px;
    }

    .hatch:hover .corner.top-right {
        top: -10px;
        right: -10px;
    }

    .hatch:hover .corner.bottom-left {
        bottom: -10px;
        left: -10px;
    }

    .hatch:hover .corner.bottom-right {
        bottom: -10px;
        right: -10px;
    }

    @media(max-width: 1750px) {
        .title {
            font-size: 84px;
        }

        .title span {
            font-size: 40px;
        }

        .description {
            margin-bottom: 70px;
            font-size: 65px;
        }

        .nft-word {
            font-size: 84px;
        }

        .egg-wrapper {
            height: 700px;
            max-width: 550px;
        }

        .hatch {
            padding: 28px;
            white-space: nowrap;
            font-size: 30px;
        }

        .egg {
            padding-top: 60px;
        }

        .button {
            font-size: 34px;
        }
    }

    @media(max-width: 1520px) {
        .title span:after {
            width: 320px;
            margin-left: -160px;
            background-size: contain;
        }
    }

    @media(max-width: 1400px) {
        section {
            padding-top: 130px;
            padding-bottom: 30px;
        }

        .egg-wrapper {
            height: 600px;
            padding-top: 30px;
        }

        .hatch {
            font-size: 26px;
        }

        .title {
            font-size: 70px;
            margin-top: 100px;
        }

        .title span {
            font-size: 34px;
        }

        .title span:after {
            width: 300px;
            margin-left: -150px;
        }

        .description {
            margin-bottom: 50px;
            font-size: 60px;
        }

        .nft-word {
            font-size: 78px;
        }

        .button {
            font-size: 30px;
        }

        .egg {
            padding-top: 0;
        }
    }

    @media(max-width: 1200px) {
        section {
            padding-top: 100px;
        }

        .egg-wrapper {
            height: 530px;
            padding-top: 60px;
        }

        .hatch {
            font-size: 22px;
            padding: 22px;
        }

        .title {
            font-size: 55px;
        }

        .title span {
            font-size: 28px;
        }

        .title span:after {
            width: 240px;
            margin-left: -120px;
        }

        .button {
            font-size: 26px;
            padding: 28px 50px 24px;
        }

        .description {
            font-size: 46px;
            margin-bottom: 40px;
        }

        .nft-word {
            font-size: 60px;
        }
    }

    @media(max-width: 991px) {
        .title {
            font-size: 40px;
            margin-top: 40px;
        }

        .title span {
            font-size: 23px;
        }

        .title span:after {
            width: 200px;
            margin-left: -100px;
        }

        .description {
            font-size: 34px;
        }

        .nft-word {
            font-size: 40px;
        }

        .egg {
            max-width: 320px;
        }

        .button {
            font-size: 20px;
            padding: 20px 36px 16px;
        }

        .hatch {
            font-size: 18px;
            padding: 18px;
        }

        .egg-wrapper:before {
            filter: blur(250px);
            width: 80%;
            height: 80%;
        }

        .egg-wrapper {
            height: 360px;
            padding-top: 0;
        }
    }

    @media(max-width: 767px) {
        section {
            padding-top: 70px;
            padding-bottom: 50px;
        }

        .title {
            font-size: 40px;
            margin-top: 40px;
            z-index: 2;
            position: relative;
        }

        .title span {
            font-size: 23px;
        }

        .title span:after {
            width: 200px;
            margin-left: -100px;
        }

        .description {
            font-size: 34px;
            margin: -50px auto 40px;
            z-index: 2;
            position: relative;
            padding-left: 10px;
            width: 340px;
        }

        .nft-word {
            font-size: 40px;
        }

        .egg {
            max-width: 220px;
        }

        .button {
            font-size: 20px;
            padding: 20px 36px 16px;
        }

        .hatch {
            font-size: 18px;
            padding: 18px;
        }

        .stars-wrapper {
            top: 50%;
            padding-top: 90px;
        }

        .egg-wrapper:before {
            filter: blur(250px);
            width: 80%;
            height: 80%;
        }

        .title span {
            font-size: 18px;
            margin: 30px 0 0 -70px;
            position: absolute;
        }

        .title span:after {
            width: 160px;
            margin-left: -80px;
            margin-top: -15px;
        }

        .egg-wrapper {
            height: auto;
            max-width: 100%;
            min-height: 100vw;
            padding: 0;
        }

        .egg {
            max-width: 100%;
        }

        .hatch {
            padding: 20px 24px;
        }

        .button {
            font-size: 26px;
            padding: 28px 52px 24px;
            margin: 0 auto;
        }

        .egg-wrapper:before {
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background: rgba(0, 148, 255, 0.7);
        }

        .nft-modal-content {
            width: 100%;
            height: 100%;
            min-height: 650px;
            overflow: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 0;
            border-radius: 0;
            left: 0;
            top: 0;
            transform: none;
            zoom: 0.7
        }

        .btn-close {
            position: fixed;
        }

        .modal-button {
            bottom: 55px;
        }

        .waitlist-button {
            bottom: 25px;
        }
    }
</style>
